module.exports = __webpack_public_path__ + "img/shield-lock.43d0c8dd.svg";